module.exports = __webpack_public_path__ + "media/images/homepage/play-icon-ec3878a9b214d9b53af84aeb2a6052d4.png";